/// <reference path="../_references.ts"/>

module App.Administrative.Reviews {
	export class ReviewRequestService {
		constructor(
			private $http: ng.IHttpService,
			public Constants: IConstants
		) {

		}

		sendCallsourceReviewRequest(data: RequestReviewData): ng.IHttpPromise<RequestReviewResponse> {
			return this.$http.post(`${this.Constants.apiUrl}requestreview`, data);
		}

		sendReviewRequest(data: RequestReviewData): ng.IHttpPromise<RequestReviewResponse> {
			return this.$http.post(`${this.Constants.apiUrl}servicerequest/${data.service_request}/sendreview`, data);
		}

		public static Factory() {
			let instance = ($http: ng.IHttpService, Constants: IConstants) => {
				return new ReviewRequestService($http, Constants);
			};

			instance.$inject = ['$http', 'Constants'];

			return instance;
		}
	}

}